class ToastService {
    constructor() {
        this.app = null;
    }

    install(app) {
        this.app = app;
        // Register as $edverumToast to avoid conflight with PrimeVue toast
        app.config.globalProperties.$edverumToast = this;
        app.provide('edverumToast', this);
    }

    /**
     * Open a toast notification.
     * Compatible with Buefy's toast signature.
     *
     * @param {Object|string} params - Either an options object or a message string
     * @param {string} params.message - The message to display
     * @param {string} [params.type] - 'is-success', 'is-danger', 'is-warning', 'is-info'
     * @param {string} [params.position] - 'is-top', 'is-bottom', 'is-top-right', 'is-top-left', 'is-bottom-right', 'is-bottom-left'
     * @param {number} [params.duration] - Duration in ms (default: 2000)
     * @param {boolean} [params.queue] - If false, clears previous toasts
     */
    open(params) {
        // Handle string shorthand: this.$edverumToast.open('message')
        if (typeof params === 'string') {
            params = { message: params };
        }

        if (this.app) {
            const $primeToast = this.app.config.globalProperties.$toast;
            if ($primeToast) {
                return this.openPrimeVueToast(params);
            }
        }

        console.warn('PrimeVue toast service is not available.');
        return { close: () => {} };
    }

    openPrimeVueToast(params) {
        const $primeToast = this.app.config.globalProperties.$toast;

        const severityMap = {
            'is-success': 'success',
            'is-danger': 'error',
            'is-warning': 'warn',
            'is-info': 'info',
        };

        const severity = severityMap[params.type] || 'secondary';
        const life = params.duration || 2000;

        const message = {
            severity: severity,
            summary: params.message,
            detail: params.details || params.message,
            life: life,
            group: params.group || 'buefy-toast',
        };

        if (params.actionLabel) message.actionLabel = params.actionLabel;
        if (params.onAction) message.onAction = params.onAction;

        $primeToast.add(message);

        return {
            close: () => {
                $primeToast.remove(message);
            },
        };
    }
}

const toastService = new ToastService();
export default toastService;
